import { TradingEngineError } from "../../shared/api/api-error.js";

function detailLines(details: unknown): readonly string[] {
  if (details === null || typeof details !== "object") return [];
  return Object.entries(details as Record<string, unknown>).flatMap(([field, value]) => {
    if (typeof value === "string") return [`${field}: ${value}`];
    if (Array.isArray(value)) {
      return value
        .filter((item): item is string => typeof item === "string")
        .map((item) => `${field}: ${item}`);
    }
    return [];
  });
}

export function ProblemNotice({ error }: { readonly error: unknown }) {
  const apiError = error instanceof TradingEngineError ? error : null;
  const lines = detailLines(apiError?.details);
  return (
    <div className="form-message form-message--error" role="alert">
      <strong>{apiError?.message ?? "TradingEngine could not complete this request."}</strong>
      {lines.length === 0 ? null : (
        <ul>
          {lines.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
      {apiError?.status === 409 ? (
        <p>This bot changed after you opened it. Reload before applying your changes.</p>
      ) : null}
      {apiError?.correlationId === null || apiError?.correlationId === undefined ? null : (
        <small>Correlation ID: {apiError.correlationId}</small>
      )}
    </div>
  );
}
